/**
 * Which tenant this tab should send as X-Tenant-Id after /me.
 *
 * Keeps the tab's own choice while the user still belongs to it (the header
 * is the source of truth, audit D3). Otherwise falls back to the server's
 * current tenant, then any membership. A stale id left behind after removal
 * made every call 403 while the UI showed another tenant (audit FE-15).
 * Super admins may work in tenants they aren't members of.
 */
export function resolveTenantHeader(
  stored: number | null,
  memberIds: number[],
  currentTenantId: number | null,
  isSuperAdmin: boolean,
): number | null {
  if (stored && (memberIds.includes(stored) || isSuperAdmin)) return stored;
  if (currentTenantId && (memberIds.includes(currentTenantId) || isSuperAdmin)) return currentTenantId;
  return memberIds[0] ?? null;
}
